module.exports = "<section class=\"ui-card card-hoverable\">\r\n  <div class=\" kd-item padding-md\">\r\n    <div class=\"flex\">\r\n      <div class=\"typo-title\">{{::$ctrl.data.descripcion | capitalize}}</div>\r\n    </div>\r\n  </div>\r\n</section>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/fan/proyecto/components/documentos/informacionfiscal/periodos/periodo/template.html
// module id = 490
// module chunks = 0